if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.syncLeftThumbnailHeight = this.syncLeftThumbnailHeight.bind(this);
        this.queueLeftThumbnailHeightSync =
          this.queueLeftThumbnailHeightSync.bind(this);

        if (this.dataset.desktopLayout === 'thumbnail_slider_left') {
          this.initLeftThumbnailHeightSync();
          this.initLeftThumbnailListInteraction();
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer?.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              ?.addEventListener(
                'click',
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false,
                  true
                )
              );
          });
        if (
          this.dataset.desktopLayout === 'thumbnail_slider' &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      connectedCallback() {
        if (this.dataset.desktopLayout !== 'thumbnail_slider_left') return;
        this.queueLeftThumbnailHeightSync();
      }

      disconnectedCallback() {
        this.mediaListResizeObserver?.disconnect();
        this.mainPanelResizeObserver?.disconnect();
        this.activeMediaResizeObserver?.disconnect();
        this.activeMediaMutationObserver?.disconnect();
        this.mqlLeftThumbs?.removeEventListener(
          'change',
          this.queueLeftThumbnailHeightSync
        );
        window.removeEventListener('resize', this.queueLeftThumbnailHeightSync);
        window.removeEventListener('load', this.queueLeftThumbnailHeightSync);
        document.removeEventListener(
          'page:loaded',
          this.queueLeftThumbnailHeightSync
        );
        this.querySelectorAll('.product__media-list img').forEach((image) => {
          image.removeEventListener('load', this.queueLeftThumbnailHeightSync);
        });
        this.destroyLeftThumbnailListInteraction();
      }

      initLeftThumbnailListInteraction() {
        this.leftThumbList = this.querySelector('.thumbnail-list');
        if (!this.leftThumbList || this.leftThumbInteractionBound) return;

        this.leftThumbInteractionBound = true;
        this.leftThumbDragMoved = false;
        this.leftThumbIsDragging = false;

        this.onLeftThumbListMouseDown =
          this.onLeftThumbListMouseDown.bind(this);
        this.onLeftThumbListMouseMove =
          this.onLeftThumbListMouseMove.bind(this);
        this.onLeftThumbListMouseUp = this.onLeftThumbListMouseUp.bind(this);
        this.onLeftThumbListClickCapture =
          this.onLeftThumbListClickCapture.bind(this);
        this.onLeftThumbItemClickScroll =
          this.onLeftThumbItemClickScroll.bind(this);
        this.onLeftThumbListWheel = this.onLeftThumbListWheel.bind(this);

        this.leftThumbList.addEventListener(
          'mousedown',
          this.onLeftThumbListMouseDown
        );
        this.leftThumbList.addEventListener(
          'click',
          this.onLeftThumbListClickCapture,
          true
        );
        this.leftThumbList.addEventListener(
          'wheel',
          this.onLeftThumbListWheel,
          {
            passive: false,
          }
        );

        this.leftThumbList
          .querySelectorAll('.thumbnail-list__item button')
          .forEach((button) => {
            button.addEventListener('click', this.onLeftThumbItemClickScroll);
          });
      }

      destroyLeftThumbnailListInteraction() {
        if (!this.leftThumbInteractionBound || !this.leftThumbList) return;

        this.leftThumbList.removeEventListener(
          'mousedown',
          this.onLeftThumbListMouseDown
        );
        this.leftThumbList.removeEventListener(
          'click',
          this.onLeftThumbListClickCapture,
          true
        );
        this.leftThumbList.removeEventListener(
          'wheel',
          this.onLeftThumbListWheel
        );
        this.leftThumbList
          .querySelectorAll('.thumbnail-list__item button')
          .forEach((button) => {
            button.removeEventListener(
              'click',
              this.onLeftThumbItemClickScroll
            );
          });

        document.removeEventListener(
          'mousemove',
          this.onLeftThumbListMouseMove
        );
        document.removeEventListener('mouseup', this.onLeftThumbListMouseUp);
        this.leftThumbList.classList.remove('is-dragging');
        this.leftThumbInteractionBound = false;
      }

      isLeftThumbListDesktop() {
        return (
          this.dataset.desktopLayout === 'thumbnail_slider_left' &&
          this.mqlLeftThumbs?.matches &&
          this.leftThumbList
        );
      }

      isLeftThumbListScrollable() {
        return (
          this.isLeftThumbListDesktop() &&
          this.leftThumbList.scrollHeight > this.leftThumbList.clientHeight
        );
      }

      onLeftThumbListMouseDown(event) {
        if (!this.isLeftThumbListScrollable() || event.button !== 0) return;

        this.leftThumbIsDragging = true;
        this.leftThumbDragMoved = false;
        this.leftThumbDragStartY = event.clientY;
        this.leftThumbDragStartScrollTop = this.leftThumbList.scrollTop;

        document.addEventListener('mousemove', this.onLeftThumbListMouseMove);
        document.addEventListener('mouseup', this.onLeftThumbListMouseUp);
      }

      onLeftThumbListMouseMove(event) {
        if (!this.leftThumbIsDragging) return;

        const deltaY = event.clientY - this.leftThumbDragStartY;
        if (Math.abs(deltaY) <= 5) return;

        if (!this.leftThumbDragMoved) {
          this.leftThumbDragMoved = true;
          this.leftThumbList.classList.add('is-dragging');
        }

        this.leftThumbList.scrollTop =
          this.leftThumbDragStartScrollTop - deltaY;
      }

      onLeftThumbListMouseUp() {
        if (!this.leftThumbIsDragging) return;

        this.leftThumbIsDragging = false;
        this.leftThumbList.classList.remove('is-dragging');

        document.removeEventListener(
          'mousemove',
          this.onLeftThumbListMouseMove
        );
        document.removeEventListener('mouseup', this.onLeftThumbListMouseUp);

        if (this.leftThumbDragMoved) {
          window.setTimeout(() => {
            this.leftThumbDragMoved = false;
          }, 0);
        }
      }

      onLeftThumbListClickCapture(event) {
        if (!this.leftThumbDragMoved) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      }

      onLeftThumbListWheel(event) {
        if (!this.isLeftThumbListScrollable()) return;

        const list = this.leftThumbList;
        const maxScrollTop = list.scrollHeight - list.clientHeight;
        const atTop = list.scrollTop <= 0;
        const atBottom = list.scrollTop >= maxScrollTop - 1;

        if ((event.deltaY < 0 && atTop) || (event.deltaY > 0 && atBottom))
          return;

        event.preventDefault();
        list.scrollTop = Math.max(
          0,
          Math.min(maxScrollTop, list.scrollTop + event.deltaY)
        );
      }

      onLeftThumbItemClickScroll(event) {
        if (!this.isLeftThumbListDesktop()) return;

        const item = event.currentTarget.closest('.thumbnail-list__item');
        if (!item) return;

        window.requestAnimationFrame(() => {
          this.adjustLeftThumbnailListAfterClick(item);
        });
      }

      adjustLeftThumbnailListAfterClick(item) {
        if (!this.leftThumbList || !item || !this.isLeftThumbListScrollable())
          return;

        const list = this.leftThumbList;
        const listRect = list.getBoundingClientRect();
        const items = Array.from(
          list.querySelectorAll('.thumbnail-list__item')
        ).filter((element) => element.offsetParent !== null);

        const visibleItems = items.filter((element) => {
          const rect = element.getBoundingClientRect();
          return rect.bottom > listRect.top && rect.top < listRect.bottom;
        });

        if (!visibleItems.length) return;

        const firstVisibleItem = visibleItems[0];
        const lastVisibleItem = visibleItems[visibleItems.length - 1];
        const itemRect = item.getBoundingClientRect();
        const gap =
          Number.parseFloat(getComputedStyle(list).rowGap) ||
          Number.parseFloat(getComputedStyle(list).gap) ||
          0;
        const step = itemRect.height + gap;
        const maxScrollTop = list.scrollHeight - list.clientHeight;

        if (item === lastVisibleItem && list.scrollTop < maxScrollTop - 1) {
          list.scrollTo({
            top: Math.min(maxScrollTop, list.scrollTop + step),
            behavior: 'smooth',
          });
          return;
        }

        if (item === firstVisibleItem && list.scrollTop > 0) {
          list.scrollTo({
            top: Math.max(0, list.scrollTop - step),
            behavior: 'smooth',
          });
        }
      }

      initLeftThumbnailHeightSync() {
        this.mqlLeftThumbs = window.matchMedia('(min-width: 750px)');
        this.mqlLeftThumbs.addEventListener(
          'change',
          this.queueLeftThumbnailHeightSync
        );
        window.addEventListener('resize', this.queueLeftThumbnailHeightSync);
        document.addEventListener(
          'page:loaded',
          this.queueLeftThumbnailHeightSync
        );
        window.addEventListener('load', this.queueLeftThumbnailHeightSync);

        const mediaList = this.querySelector('.product__media-list');
        const mainPanel =
          this.querySelector('use-animate') ||
          this.querySelector('product-gallery');

        if (mediaList) {
          this.mediaListResizeObserver = new ResizeObserver(
            this.queueLeftThumbnailHeightSync
          );
          this.mediaListResizeObserver.observe(mediaList);

          this.activeMediaMutationObserver = new MutationObserver(
            this.queueLeftThumbnailHeightSync
          );
          this.activeMediaMutationObserver.observe(mediaList, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true,
          });
        }

        if (mainPanel) {
          this.mainPanelResizeObserver = new ResizeObserver(
            this.queueLeftThumbnailHeightSync
          );
          this.mainPanelResizeObserver.observe(mainPanel);
        }

        this.querySelectorAll('.product__media-list img').forEach((image) => {
          if (image.complete) return;
          image.addEventListener('load', this.queueLeftThumbnailHeightSync, {
            once: true,
          });
        });

        this.queueLeftThumbnailHeightSync();
      }

      queueLeftThumbnailHeightSync() {
        window.requestAnimationFrame(() => {
          this.syncLeftThumbnailHeight();
          window.requestAnimationFrame(this.syncLeftThumbnailHeight);
        });
        window.setTimeout(this.syncLeftThumbnailHeight, 100);
        window.setTimeout(this.syncLeftThumbnailHeight, 500);
      }

      getElementPaddingVertical(element) {
        if (!element) return { top: 0, bottom: 0, total: 0 };

        const styles = getComputedStyle(element);
        const top = Number.parseFloat(styles.paddingTop) || 0;
        const bottom = Number.parseFloat(styles.paddingBottom) || 0;

        return { top, bottom, total: top + bottom };
      }

      getLeftThumbnailLayoutMetrics(
        panelHeight,
        thumbnailSlider,
        thumbnailList
      ) {
        const visibleCount =
          Number.parseInt(thumbnailList?.dataset.visibleCount, 10) || 7;
        const listStyles = thumbnailList
          ? getComputedStyle(thumbnailList)
          : null;
        const gap = listStyles
          ? Number.parseFloat(listStyles.gap) ||
            Number.parseFloat(listStyles.rowGap) ||
            8
          : 8;
        const sliderPadding = this.getElementPaddingVertical(thumbnailSlider);
        const listPadding = this.getElementPaddingVertical(thumbnailList);
        const sliderHeight = panelHeight;
        const listHeight = sliderHeight - sliderPadding.total;
        const rowsArea = listHeight - listPadding.total;
        const itemSize = (rowsArea - (visibleCount - 1) * gap) / visibleCount;

        return {
          visibleCount,
          gap,
          panelHeight,
          sliderHeight,
          listHeight,
          rowsArea,
          itemSize,
        };
      }

      applyLeftThumbnailMetrics(metrics) {
        const thumbnailSlider = this.querySelector('.thumbnail-slider');
        const thumbnailList = this.querySelector('.thumbnail-list');

        if (!thumbnailList || !metrics) return;

        this.style.setProperty(
          '--left-thumb-visible-count',
          `${metrics.visibleCount}`
        );
        this.style.setProperty(
          '--product-media-list-height',
          `${metrics.sliderHeight}px`
        );
        this.style.setProperty(
          '--left-thumb-item-size',
          `${metrics.itemSize}px`
        );

        if (thumbnailSlider) {
          thumbnailSlider.style.setProperty(
            'height',
            `${metrics.sliderHeight}px`,
            'important'
          );
          thumbnailSlider.style.setProperty(
            'max-height',
            `${metrics.sliderHeight}px`,
            'important'
          );
        }

        thumbnailList.style.setProperty(
          'height',
          `${metrics.listHeight}px`,
          'important'
        );
        thumbnailList.style.setProperty(
          'max-height',
          `${metrics.listHeight}px`,
          'important'
        );
        thumbnailList.setAttribute('data-sync-height', 'true');
      }

      getActiveMediaHeight() {
        const mainPanel =
          this.querySelector('use-animate') ||
          this.querySelector('product-gallery');

        if (!mainPanel) return 0;

        return Math.round(mainPanel.getBoundingClientRect().height);
      }

      getLeftThumbnailSliderOffset(thumbnailSlider) {
        if (!thumbnailSlider) return 0;

        const styles = getComputedStyle(thumbnailSlider);
        const marginTop = Number.parseFloat(styles.marginTop) || 0;
        const marginBottom = Number.parseFloat(styles.marginBottom) || 0;

        return Math.max(0, -marginTop) + Math.max(0, -marginBottom);
      }

      applyLeftThumbnailHeight(height) {
        const mainPanel =
          this.querySelector('use-animate') ||
          this.querySelector('product-gallery');
        const thumbnailSlider = this.querySelector('.thumbnail-slider');
        const thumbnailList = this.querySelector('.thumbnail-list');

        if (!thumbnailList || !mainPanel) return;

        const sliderOffset = this.getLeftThumbnailSliderOffset(thumbnailSlider);
        const syncedPanelHeight = height + sliderOffset;
        const metrics = this.getLeftThumbnailLayoutMetrics(
          syncedPanelHeight,
          thumbnailSlider,
          thumbnailList
        );

        this.applyLeftThumbnailMetrics(metrics);

        window.requestAnimationFrame(() => {
          this.alignLeftThumbnailSliderToMainPanel(mainPanel, thumbnailSlider);
        });
      }

      alignLeftThumbnailSliderToMainPanel(mainPanel, thumbnailSlider) {
        if (!mainPanel || !thumbnailSlider) return;

        const thumbnailList = this.querySelector('.thumbnail-list');
        const panelRect = mainPanel.getBoundingClientRect();
        const sliderRect = thumbnailSlider.getBoundingClientRect();
        const topDelta = Math.round(panelRect.top - sliderRect.top);
        const bottomDelta = Math.round(panelRect.bottom - sliderRect.bottom);

        if (Math.abs(topDelta) > 1) {
          thumbnailSlider.style.setProperty(
            'margin-top',
            `${topDelta}px`,
            'important'
          );
        } else {
          thumbnailSlider.style.removeProperty('margin-top');
        }

        if (Math.abs(topDelta) <= 1 && Math.abs(bottomDelta) <= 1) return;

        const metrics = this.getLeftThumbnailLayoutMetrics(
          Math.round(panelRect.height),
          thumbnailSlider,
          thumbnailList
        );
        this.applyLeftThumbnailMetrics(metrics);
      }

      clearLeftThumbnailHeight() {
        const thumbnailSlider = this.querySelector('.thumbnail-slider');
        const thumbnailList = this.querySelector('.thumbnail-list');

        this.style.removeProperty('--product-media-list-height');
        this.style.removeProperty('--left-thumb-item-size');

        [thumbnailSlider, thumbnailList].forEach((element) => {
          if (!element) return;
          element.style.removeProperty('height');
          element.style.removeProperty('max-height');
        });

        thumbnailSlider?.style.removeProperty('margin-top');
        thumbnailList?.removeAttribute('data-sync-height');
      }

      observeActiveMediaItem(activeItem) {
        this.activeMediaResizeObserver?.disconnect();

        if (!activeItem) return;

        this.activeMediaResizeObserver = new ResizeObserver(
          this.queueLeftThumbnailHeightSync
        );
        this.activeMediaResizeObserver.observe(activeItem);
      }

      syncLeftThumbnailHeight() {
        const mediaList = this.querySelector('.product__media-list');

        if (!mediaList || !this.querySelector('.thumbnail-list')) return;

        if (
          this.dataset.desktopLayout !== 'thumbnail_slider_left' ||
          !this.mqlLeftThumbs?.matches
        ) {
          this.clearLeftThumbnailHeight();
          return;
        }

        const activeItem = mediaList.querySelector(
          '.product__media-item.is-active'
        );
        this.observeActiveMediaItem(activeItem);

        const height = this.getActiveMediaHeight();
        if (!height) return;

        this.applyLeftThumbnailHeight(height);
      }

      onSlideChanged(event) {
        if (event.detail.currentElement == undefined) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.queueLeftThumbnailHeightSync();
      }

      setActiveMedia(mediaId, prepend, scrollIntoView = true) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            (!this.elements.thumbnails ||
              this.dataset.desktopLayout === 'stacked') &&
            scrollIntoView
          ) {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
          this.queueLeftThumbnailHeightSync();
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('[id^="Slide-"]')
          .forEach((element) => {
            element.classList.remove('is-active');
            element.querySelector('button')?.removeAttribute('aria-current');
          });
        thumbnail.classList.add('is-active');
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            theme.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
          this.queueLeftThumbnailHeightSync();
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}
